import { useEffect } from 'react';
import { useCapability } from '../../useCapability';
import { capabilities } from '../../../../capabilities';
import { getWindow } from '../../../../common/utils';
const isEmptyArray = value => Array.isArray(value) && value.length === 0;
const reloadPage = () => {
  try {
    getWindow().location.reload();
  } catch (error) {
    /**
     * No special handling required
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Location/reload#securityerror
     */
  }
};
const navigateTo = ({
  url,
  openInNewTab,
  openInNewWindow
}) => {
  const targetUrl = decodeURI(url);
  try {
    if (openInNewTab) {
      getWindow().open(targetUrl, '_blank', 'noopener');
    } else if (openInNewWindow) {
      const {
        outerHeight,
        outerWidth
      } = getWindow();
      getWindow().open(targetUrl, '_blank', `noopener,width=${outerWidth},height=${outerHeight}`);
    } else {
      getWindow().location.assign(targetUrl);
    }
  } catch (error) {
    /* No special handling required */
  }
};
const updateQueryParam = ({
  key,
  value
}) => {
  const {
    location: {
      search,
      pathname
    },
    history
  } = getWindow();
  const urlQueryParams = new URLSearchParams(search);
  if (value === '' || value === undefined || isEmptyArray(value)) {
    urlQueryParams.delete(key);
  } else {
    urlQueryParams.set(key, value.toString());
  }
  const serialized = urlQueryParams.toString();
  const paramString = serialized === '' ? pathname : `?${serialized}`;
  history.replaceState({}, '', paramString);
};
export const useLocationCapabilities = () => {
  const {
    subscribe: onUpdateQueryParam
  } = useCapability(capabilities.UPDATE_QUERY_PARAM_CAP.getName());
  const {
    subscribe: onReloadPage
  } = useCapability(capabilities.RELOAD_PAGE_CAP.getName());
  const {
    subscribe: onNavigateTo
  } = useCapability(capabilities.NAVIGATE_TO_CAP.getName());
  useEffect(() => {
    const unsubscribeNavigateTo = onNavigateTo(navigateTo);
    const unsubscribeReloadPage = onReloadPage(reloadPage);
    const unsubscribeUpdateQueryParam = onUpdateQueryParam(updateQueryParam);
    return () => {
      unsubscribeNavigateTo();
      unsubscribeReloadPage();
      unsubscribeUpdateQueryParam();
    };
  }, [onNavigateTo, onReloadPage, onUpdateQueryParam]);
};